import isFinite from 'lodash/isFinite';
import isNaN from 'lodash/isNaN';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';

function price(input) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(input);
}

function number(input, digits = 0, useGrouping = false, options = {}) {
  if (isNull(input) || isUndefined(input) || isNaN(input)) {
    return '';
  }

  return new Intl.NumberFormat('nl-NL', {
    style: 'decimal',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
    useGrouping,
    ...options,
  }).format(input);
}

function license(value) {
  if (!value) {
    return value;
  }

  const chunks = value.match(/[a-zA-Z]+|\d+/g) ?? [];
  const grouped = chunks.flatMap((chunk) =>
    chunk.length === 4 ? [chunk.slice(0, 2), chunk.slice(2)] : [chunk],
  );

  return grouped.join('-').toUpperCase();
}

function address(value) {
  if (typeof value === 'string') {
    return value;
  }

  return `${value.postalCode} ${value.houseNumber} ${value.annex || ''}`.trim();
}

function round(value, precision = 2) {
  const factor = Math.pow(10, precision);
  return Math.round(value * factor) / factor;
}

const is_finite_number = (value) => isFinite(Number.parseInt(value, 10));

export default {
  price,
  number,
  license,
  address,
  round,
  is_finite_number,
};
